const SETUP_KEY = "setupContext";

export const setSetupContext = (descriptor) => {
  try {
    localStorage.setItem(SETUP_KEY, JSON.stringify(descriptor));
  } catch (e) {
    console.error("Unable to persist setup context", e?.message);
  }
};

export const getSetupContext = () => {
  try {
    const raw = localStorage.getItem(SETUP_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const getSetupContextFor = (eventId) => {
  const descriptor = getSetupContext();
  if (!descriptor) return null;
  if (eventId && String(descriptor.eventId) !== String(eventId)) return null;
  return descriptor;
};

export const clearSetupContext = () => {
  try {
    localStorage.removeItem(SETUP_KEY);
  } catch (e) {
    /* no-op */
  }
};
